import React from 'react';
import { Flex, Box } from 'reflexbox';
import { Link } from 'react-router';
import { prefixLink } from 'gatsby-helpers';
import styled from 'styled-components';

module.exports = React.createClass({
  propTypes () {
    return {
        children: React.PropTypes.any,
    }
  },
  render () {
    return (
      <header>
        <div className="container">
          <Flex className="shift">
            <Box sm={6} md={3}>
              <div className="bio">
                <Photo src="https://github.com/ckj.png" className="photo"/>
                <Logo to={prefixLink('/')} className="logo">
                  @ckj
                </Logo>
                <p>co-founder / designer @ <a href="https://sentry.io">sentry.io</a></p>
              </div>
            </Box>
            <Box sm={6} md={6}>
              <Menu>
                <MenuItem md={3}>
                  <Link to={prefixLink('/about/')} activeClassName="active">about</Link>
                </MenuItem>
                <MenuItem md={3}>
                  <Link to={prefixLink('/design/')} activeClassName="active">design</Link>
                </MenuItem>
                <MenuItem md={3}>
                  <Link to={prefixLink('/code/')} activeClassName="active">code</Link>
                </MenuItem>
                <MenuItem md={3}>
                  <Link to={prefixLink('/tweets/')} activeClassName="active">tweets</Link>
                </MenuItem>
              </Menu>
            </Box>
            <Box sm={6} md={3} style={{textAlign: "right"}}>
              <FollowButton className="follow-button" href="https://twitter.com/ckj">Follow</FollowButton>
            </Box>
          </Flex>
        </div>
      </header>
    )
  },
})

const Logo = styled(Link)`
  display: block;
  font-size: 36px;
  color: #312A33;
  transition: 1.5s ease;
`;

const Menu = styled(Flex)`
  text-align: center;
`;

const MenuItem = styled(Box)`
  font-size: 14px;
  padding: 13px 0;

  a {
    position: relative;
    display: block;
    color: #BFB3C4;
    transition: color .8s;

    &:hover {
      color: #8F8193;
    }

    &:after {
      transition: background .6s;
      transition-delay: 1.4s;
      position: absolute;
      content: "";
      display: block;
      bottom: -25px;
      height: 8px;
      width: 8px;
      border-radius: 8px;
      margin-left: -4px;
      left: 50%;
      background: #fff;
    }

    &.active{
      color: #312A33;

      &:after {
        background: #7263FF;
      }
    }
  }
`;

const FollowButton = styled.a`
  font-size: 14px;
  display: inline-block;
  background: #000;
  color: #fff;
  padding: 6px 18px;
  background: #A09DB8;
  box-shadow: 0 3px 24px 0 rgba(48,42,51,0.12);
  border-radius: 28px;
  margin-top: 5px;
  transition: 1.5s opacity;
  transition-delay: 1.4s;
`;

const Photo = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 120px;
  box-shadow: 0 3px 20px 0 rgba(48,42,51,0.06);
`;



// WEBPACK FOOTER //
// ./components/_header.js